import script from "./BonusUhidWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./BonusUhidWidget.vue?vue&type=script&setup=true&lang=js"

import "./BonusUhidWidget.vue?vue&type=style&index=0&id=942207dc&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-942207dc"]])

export default __exports__